import { createFileRoute, Outlet } from '@tanstack/react-router';

import { NavigationSidebarManufacturer } from '@/areas/parts/ManufacturerManagement/NavigationSidebarManufacturer';
import type { PageStaticData } from '@/shared/routing';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// The pages beside the Manufacturers sidebar; the details page and the importer stay outside this group.
export const Route = createFileRoute('/_authenticated/manufacturers/_sidebar')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarRouteLayout sidebar={<NavigationSidebarManufacturer />}>
            <Outlet />
        </SidebarRouteLayout>
    );
}
